import {
  customer_category_mappings_create_post,
  customer_category_mappings_import_post,
  customer_category_mappings_mappingId_copy_post,
  customer_category_mappings_mappingId_customerCategories_get,
  customer_category_mappings_mappingId_delete_post,
  customer_category_mappings_mappingId_export_post,
  customer_category_mappings_mappingId_get,
  customer_category_mappings_mappingId_rules_batchUpsert_post,
  customer_category_mappings_mappingId_rules_cancel_post,
  customer_category_mappings_mappingId_rules_list_get,
  customer_category_mappings_mappingId_rules_upsert_post,
  customer_category_mappings_mappingId_status_post,
  customer_category_mappings_mappingId_update_post,
  customer_category_mappings_page_post
} from '@/server/modules/25813'

const unwrap = response => {
  if (response?.success === false) {
    throw new Error(response.retInfo || '接口请求失败')
  }
  return response?.data
}

const pageData = (data, normalizer) => {
  const source = data || {}
  const list = source.list || source.records || source.rows || []
  return {
    list: list.map(normalizer),
    total: Number(source.total ?? source.totalCount ?? list.length),
    pageNum: Number(source.pageNum || 1),
    pageSize: Number(source.pageSize || 10)
  }
}

export const mappingStatusText = status =>
  ({ 0: '草稿', 1: '已启用', 2: '已停用' }[Number(status)] || '未知')

export const normalizeCustomerCategoryMapping = item => ({
  ...item,
  id: item.mappingId ?? item.id,
  mappingId: item.mappingId ?? item.id,
  mappingName: item.mappingName || item.name || '',
  description: item.description || '',
  treeId: item.treeId ?? item.customerCategoryTreeId,
  treeName:
    item.treeName || item.customerCategoryTreeName || item.boundTreeName || '',
  status: Number(item.status ?? 0),
  mappedCount: Number(item.mappedCount ?? item.mappingCount ?? 0),
  totalCount: Number(item.totalCount ?? item.systemCategoryCount ?? 0),
  coverageRate:
    item.coverageRate ?? item.coverage ?? item.mappingCoverage ?? undefined,
  enableTime:
    item.enabledTime ||
    item.enableTime ||
    item.enabledAt ||
    item.effectiveTime ||
    '-',
  updateTime:
    item.lastUpdateTime ||
    item.updateTime ||
    item.updatedAt ||
    item.modifyTime ||
    '-'
})

export const normalizeMappingRule = item => {
  const chinesePath = `${item.systemChinesePath || ''}`
    .split(/\s*>\s*|\s*\/\s*/)
    .filter(Boolean)
  const englishPath = `${item.systemEnglishPath || ''}`
    .split(/\s*>\s*|\s*\/\s*/)
    .filter(Boolean)
  return {
    ...item,
    id: item.ruleId ?? item.id ?? item.systemCategoryId,
    ruleId: item.ruleId ?? item.id,
    systemCategoryId:
      item.systemCategoryId ??
      item.systemThirdCategoryId ??
      item.categoryL3Id ??
      item.categoryId,
    systemLevelOneId:
      item.systemLevelOneId ??
      item.systemFirstCategoryId ??
      item.categoryL1Id ??
      item.levelOneId,
    systemLevelOneName:
      item.systemLevelOneName ||
      item.systemFirstCategoryName ||
      item.categoryL1ZhName ||
      item.levelOneName ||
      chinesePath[0] ||
      '',
    systemLevelTwoName:
      item.systemLevelTwoName ||
      item.systemSecondCategoryName ||
      item.categoryL2ZhName ||
      item.levelTwoName ||
      chinesePath[1] ||
      '',
    systemLevelThreeName:
      item.systemLevelThreeName ||
      item.systemThirdCategoryName ||
      item.categoryL3ZhName ||
      item.levelThreeName ||
      item.systemCategoryName ||
      chinesePath[2] ||
      '',
    systemCategoryEnglishName:
      item.systemCategoryEnglishName ||
      item.categoryL3Name ||
      item.englishName ||
      item.nameEn ||
      englishPath[englishPath.length - 1] ||
      '',
    customerCategoryNodeId:
      item.customerCategoryNodeId ??
      item.customerNodeId ??
      item.targetCategoryId,
    customerCategoryPath:
      item.customerCategoryPath ||
      item.customerPath ||
      item.targetCategoryPath ||
      '',
    mappingState:
      item.mappingState ||
      (item.mapped === true ||
      item.customerCategoryNodeId ||
      item.customerNodeId
        ? 'MAPPED'
        : 'UNMAPPED')
  }
}

export const listCustomerCategoryMappings = async params => {
  const payload = { ...params }
  if (payload.status === '' || payload.status === undefined) {
    delete payload.status
  } else {
    payload.status = Number(payload.status)
  }
  return pageData(
    unwrap(await customer_category_mappings_page_post(payload)),
    normalizeCustomerCategoryMapping
  )
}

export const getCustomerCategoryMapping = async mappingId => {
  const data = unwrap(
    await customer_category_mappings_mappingId_get({ mappingId })
  )
  return data ? normalizeCustomerCategoryMapping(data) : null
}

export const createCustomerCategoryMapping = async payload => {
  const data = unwrap(await customer_category_mappings_create_post(payload))
  const id = data?.mappingId ?? data?.id ?? data
  return { id, mappingId: id }
}

export const copyCustomerCategoryMapping = async (mappingId, mappingName) => {
  const data = unwrap(
    await customer_category_mappings_mappingId_copy_post({
      mappingId,
      mappingName
    })
  )
  const id = data?.mappingId ?? data?.id ?? data
  return { id, mappingId: id }
}

export const deleteCustomerCategoryMapping = async mappingId => {
  return unwrap(
    await customer_category_mappings_mappingId_delete_post({ mappingId })
  )
}

export const updateCustomerCategoryMapping = async (mappingId, payload) => {
  return unwrap(
    await customer_category_mappings_mappingId_update_post({
      mappingId,
      ...payload
    })
  )
}

export const changeCustomerCategoryMappingStatus = async (
  mappingId,
  payload
) => {
  return unwrap(
    await customer_category_mappings_mappingId_status_post({
      mappingId,
      ...payload
    })
  )
}

export const exportCustomerCategoryMapping = async mappingId => {
  return unwrap(
    await customer_category_mappings_mappingId_export_post({ mappingId })
  )
}

export const importCustomerCategoryMapping = async payload => {
  const response = await customer_category_mappings_import_post({
    brandId: payload.brandId,
    siteId: payload.siteId,
    mappingName: payload.mappingName,
    description: payload.description || '',
    treeId: payload.treeId,
    file: payload.file
  })
  if (Array.isArray(response?.data?.errors) && response.data.errors.length) {
    return response.data
  }
  return unwrap(response)
}

export const listCustomerCategoryMappingRules = async mappingId => {
  const data = unwrap(
    await customer_category_mappings_mappingId_rules_list_get({ mappingId })
  )
  const source = Array.isArray(data)
    ? data
    : data?.list || data?.records || data?.rows || []
  return source.map(normalizeMappingRule)
}

export const getSelectableCustomerCategories = async mappingId => {
  const data = unwrap(
    await customer_category_mappings_mappingId_customerCategories_get({
      mappingId
    })
  )
  const list = Array.isArray(data)
    ? data
    : data?.list || data?.nodes || data?.categories || []
  return list.map(item => ({
    ...item,
    id: item.customerCategoryNodeId ?? item.nodeId ?? item.id,
    name:
      item.customerCategoryName ||
      item.defaultName ||
      item.categoryName ||
      item.name ||
      '',
    path:
      item.customerCategoryPath ||
      item.customerCategoryNodePath ||
      item.fullPath ||
      item.categoryPath ||
      item.path ||
      item.defaultName ||
      item.name ||
      ''
  }))
}

export const upsertCustomerCategoryMappingRule = async (mappingId, payload) => {
  return unwrap(
    await customer_category_mappings_mappingId_rules_upsert_post({
      mappingId,
      ...payload
    })
  )
}

export const batchUpsertCustomerCategoryMappingRules = async (
  mappingId,
  rules
) => {
  return unwrap(
    await customer_category_mappings_mappingId_rules_batchUpsert_post({
      mappingId,
      rules
    })
  )
}

export const cancelCustomerCategoryMappingRules = async (
  mappingId,
  categoryL3Ids
) => {
  return unwrap(
    await customer_category_mappings_mappingId_rules_cancel_post({
      mappingId,
      categoryL3Ids
    })
  )
}
